// extracted by mini-css-extract-plugin
module.exports = {"memberCol":"LicenseList_memberCol_J2r03"};